import React from 'react';
import Header from '@templates/header';
import { Link, Breadcrumb, Button } from 'vindi-ds-components';

function ShowProductHeader({ name, id }) {
  return (
    <Header>
      <Header.Navigation>
        <Breadcrumb
          links={[
            <Link href='/admin/configuration'>Configurações</Link>,
            <Link href='/admin/products'>Produtos</Link>,
          ]}
        >
          { name }
        </Breadcrumb>
      </Header.Navigation>
      <Header.Title>{name}</Header.Title>
      <Header.Actions>
        <Button href={`/admin/products/${id}/edit`}>Editar Produto</Button>
      </Header.Actions>
    </Header>
  );
}

export default ShowProductHeader;
